import { render, staticRenderFns } from "./IssueDocumentSignature.vue?vue&type=template&id=2c1c2baa&scoped=true"
import script from "./IssueDocumentSignature.vue?vue&type=script&lang=ts"
export * from "./IssueDocumentSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c2baa",
  null
  
)

export default component.exports